import Duplicate from "modules/formTemplates/components/Duplicate";
import React from "react";

const FormTemplatesDuplicatePage = () => {
  return <Duplicate />;
};

export default FormTemplatesDuplicatePage;
